import { selectUserState, userActions } from "app/store/slices/user";
import { useAppDispatch, useAppSelector } from "app/store/store";
import type { NextPage } from "next";
import Head from "next/head";
import React, { useEffect } from "react";
import Loader from "app/components/icons/Loader";
import styles from "./deezer.module.scss";
import { useRouter } from "next/router";
import { postPillowUserV2UsersMeDeezer } from "services-hooks/services";
import { useTranslate } from "app/hooks/lang";
import { useNavigatePath } from "app/hooks/navigation.hook";
import useMetaDescription from "app/utils/getMetaDescription";

const Deezer: NextPage = () => {
  const navigatePath = useNavigatePath();
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { code } = router.query;
  const { session } = useAppSelector(selectUserState);
  const getMetaDescription = useMetaDescription();

  useEffect(() => {
    if (session?.user?.deezer_connect) {
      navigatePath("/settings");
    }
  }, [session?.user?.deezer_connect]);

  const sendRequest = async () => {
    if (code) {
      try {
        const data = await postPillowUserV2UsersMeDeezer({
          code: code as string,
          app_id: process.env.NEXT_PUBLIC_DEEZER_CLIENT_ID!,
          redirect_uri: `${window.location.origin}/deezer`,
          perms: "offline_access,manage_library",
        });
        if (data) {
          dispatch(userActions.setUser(data.data.data));
        }
      } catch (e) {
      } finally {
        navigatePath("/settings");
      }
    }
  };

  useEffect(() => {
    if (code) {
      if (session?.user && !session?.user?.deezer_connect) {
        sendRequest();
      }
    } else {
      navigatePath("/settings");
    }
  }, [code]);
  
  const t = useTranslate();

  return (
    <div className={styles.container}>
      <Head>
        <title>Deezer - Radioline</title>
        { getMetaDescription(t('settings.deezer-meta-description')) }
      </Head>
      <div className={styles.wrapper}>
        <Loader />
      </div>
    </div>
  );
};

export default Deezer;
